import Pusher from 'pusher-js';

const pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
  cluster: process.env.REACT_APP_PUSHER_CLUSTER,
});

console.log("Pusher | Pusher initialized");

const subscribeToPusherEvent = (eventName, callback) => {
  const channel = pusher.subscribe("admin-channel");
  channel.bind(eventName, (data) => {
    console.log(`Pusher | Received msg: ${JSON.stringify(data)}`);
    callback(data);
  });

  return () => {
    channel.unbind(eventName, callback);
    channel.unsubscribe();
  };
};

export { subscribeToPusherEvent };